import { ResponseDialogComponent } from './../response/response-dialog.component';
import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthenticationService } from '@app/@core/auth/authentication.service';
import { CheckRecoveryDTO } from '@app/@core/models/login-models';
import { LoaderGenericService } from '@app/@shared/loader-generic/loader-generic.service';
import { ContactoComponent } from '../contacto/contacto.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-password-recovery',
  templateUrl: './password-recovery.component.html',
  styleUrls: ['./password-recovery.component.scss'],
})
export class PasswordRecoveryComponent implements OnInit {
  public passwordRecoveryForm: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private dialogRef: MatDialogRef<PasswordRecoveryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private loaderGenericService: LoaderGenericService,
    private authenticationService: AuthenticationService,
    private dialog: MatDialog,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.passwordRecoveryForm = this.formBuilder.group({
      user: ['', Validators.required],
    });

    if (this.data && this.data.username && this.data.username !== '') {
      this.passwordRecoveryForm.controls.user.setValue(this.data.username);
    }
  }

  accept() {
    this.loaderGenericService.showSpinner();
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '90%';
    dialogConfig.maxWidth = '700px';
    const checkUser: CheckRecoveryDTO = { user: this.passwordRecoveryForm.controls.user.value };
    if (checkUser) {
      this.authenticationService
        .checkPasswordRecovery(checkUser)
        .toPromise()
        .then(
          (data) => {
            if (data) {
              dialogConfig.width = '90%';
              dialogConfig.maxWidth = '500px';
              dialogConfig.data = {
                title: this.translate.instant('dialog.passwordRecovery.emailSent'),
                text: this.translate.instant('dialog.passwordRecovery.emailSentText'),
                noRedirect: true,
              };
              this.dialogRef.close();
              this.dialog.open(ResponseDialogComponent, dialogConfig);
            } else {
              dialogConfig.width = '90%';
              dialogConfig.maxWidth = '700px';
              this.dialogRef.close();
              this.dialog.open(ContactoComponent, dialogConfig);
            }
          },
          (error) => {
            console.error(error);
          }
        )
        .catch((error) => {
          console.error(error);
        })
        .finally(() => this.loaderGenericService.stopSpinner());
    }
  }
}
